import { ReactNode } from 'react';
import { clsx } from 'clsx';
import Pill from 'components/DesignSystem/Pill/Pill';

interface SelectionCardProps {
  titleText: string;
  titlePillText: string;
  icon: ReactNode;
  descriptionText: string;
  descriptionPillTexts: string[];
  isSelected: boolean;
  onClick: () => void;
}

const SelectionCard = ({
  titleText,
  titlePillText,
  icon,
  descriptionText,
  descriptionPillTexts,
  isSelected,
  onClick,
}: SelectionCardProps) => {
  return (
    <button
      className={clsx(
        'flex w-full items-start gap-4 rounded-lg border-2 p-4 text-left h-fit',
        isSelected
          ? 'border-primary-d-600 bg-[#F0F7F6]'
          : 'border-gray-d-300 bg-white',
      )}
      onClick={onClick}
      type="button"
    >
      <div
        className={clsx(
          'rounded-lg p-1 text-white w-[40px] h-[40px]',
          isSelected ? 'bg-primary-d-700' : 'bg-[#E8693A]',
        )}
      >
        {icon}
      </div>
      <div className="flex flex-1 flex-col gap-3">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-lg text-gray-d-900">
            {titleText}
          </span>
          <Pill isActive={isSelected} isPrimary label={titlePillText} />
        </div>
        <div className="font-light text-sm text-gray-d-500">
          {descriptionText}
        </div>
        <div className="flex flex-wrap gap-2">
          {descriptionPillTexts.map((text) => (
            <Pill key={text} isActive={isSelected} label={text} />
          ))}
        </div>
      </div>
      <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border-2 border-orange-d-700">
        {isSelected && (
          <div className="h-2.5 w-2.5 rounded-full bg-orange-d-700" />
        )}
      </div>
    </button>
  );
};

export default SelectionCard;
